import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const resetPassword = async (
  formData: { new_password: string },
  uidb64: string,
  token: string,
) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/user/password_reset/confirm/${uidb64}/${token}/`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Reset Password Error:", error);
    throw error;
  }
};
